import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';

export const useLanguageRouting = () => {
  const { i18n } = useTranslation();
  const [location, setLocation] = useLocation();

  // Set language from URL on initial load (no redirects)
  useEffect(() => {
    const currentPath = location;
    const pathParts = currentPath.split('/').filter(Boolean);
    const pathLang = pathParts[0];
    
    // Only set language from URL if it's a valid language code
    if (pathLang && ['de', 'fr', 'vi', 'es'].includes(pathLang)) {
      // Set language without triggering redirect
      if (i18n.language !== pathLang) {
        i18n.changeLanguage(pathLang);
      }
    } else if (!pathLang || pathLang === 'en') {
      // Default to English for root path or English path
      if (i18n.language !== 'en') {
        i18n.changeLanguage('en');
      }
    }
  }, [location]); // Only depend on location, not i18n.language to prevent loops

  // Function to get localized path
  const getLocalizedPath = (path: string, lang?: string) => {
    const targetLang = lang || i18n.language;
    
    // Normalize path - remove leading slash if exists
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    
    if (targetLang === 'en') {
      return normalizedPath ? `/${normalizedPath}` : '/';
    }
    
    // For non-English languages, add language prefix
    return `/${targetLang}${normalizedPath ? `/${normalizedPath}` : ''}`;
  };

  return { getLocalizedPath };
};
